import {Vue} from "ui.vue";

import {VuexBasketRestClient} from "./lib/rest.js";

/**
 *
 * @package citrus.vuex.basket
 */
const basket = {
	namespaced: true,
	state: {
		count: 0,
		products: [],
		totalPrice: 0
	},
	actions: {
		remove(store, productId) {
			if (false === store.dispatch('check', productId)) {
				return false;
			}

			productId = typeof productId === 'number' ? productId : parseInt(productId);
			store.commit('removeProduct', productId);
		},
		add(store, payload) {
			if (true === store.getters.check(payload.productId)) {
				return false;
			}

			let productId = typeof payload.productId === 'number' ? payload.productId : parseInt(payload.productId);
			let quantity = typeof payload.quantity === 'number' ? payload.quantity : parseInt(payload.quantity);

			let restClient = new VuexBasketRestClient(productId,quantity);
			return restClient.add().then((result) => {
				store.commit('addProduct', result.product);
				store.commit('increment', true);

				Vue.event.$emit('Citrus.Component.Basket:update');
				Vue.event.$emit('Citrus.Vue.Product:addedToBasket', payload);
			});
		},
		check(store, productId) {
			productId = typeof productId === 'number' ? productId : parseInt(productId);
			return store.getters.check(productId);
		},
		load(store) {
			let restClient = new VuexBasketRestClient();

			return restClient.load().then((result) => {
				store.commit('totalPrice', result.totalPrice);
				store.commit('loadProducts', result.products);

				store.dispatch('set', result.count);
			});
		},
		set(store, count) {
			store.commit('setProductsCount', count);
		},
	},
	mutations: {
		increment(state, status) {
			let increment = status ? 1 : -1;
			let value = state.count;

			state.count = value + increment;
			if(state.count < 0)
				state.count = 0;
		},
		totalPrice(state, price) {
			state.totalPrice = price;
		},
		setProductsCount(state, count) {
			state.count = count;
		},
		loadProducts(state, products) {
			state.products = products;
		},
		removeProduct(state, id) {
			let result = state.products.filter(elem => elem != id);
			state.products = result;
		},
		addProduct(state, id) {
			state.products.push(id);
		}
	},
	getters: {
		totalPrice: state => state.totalPrice,
		count: state => state.count,
		check: state => id => {
			id = typeof id === 'number' ? id : parseInt(id);
			return (state.products.indexOf(id) >= 0);
		},
		index: state => id => {
			id = typeof id === 'number' ? id : parseInt(id);
			return state.products.indexOf(id);
		}
	}
};

export {basket};

